const STORAGE_COLUMNS_ORDER = 'storageColumnsOrder'

export class StorageColumnsOrder {
  static get() {
    return JSON.parse(localStorage.getItem(STORAGE_COLUMNS_ORDER))
  }

  static set(newColumnsOrder) {
    localStorage.setItem(STORAGE_COLUMNS_ORDER, JSON.stringify(newColumnsOrder))
  }
}
